import styled, { css } from "styled-components";
import "react-multi-carousel/lib/styles.css";

//ProgressBar 인터페이스 정의
interface ProgressBarProps {
  progress: string;
}

interface FileEditBtnProps {
  function?: string;
  status?: boolean;
}

export const TaskBox = styled.div`
  position: absolute;
  display: flex;
  width: calc(100vw - 32px);
  left: 16px;
  bottom: 16px;
  align-items: flex-end;
  flex-direction: column;
  gap: 6px;
`;

export const TaskTotalWrap = styled.div`
  position: relative;
  display: flex;
  height: 50px;
  padding: 0 20px;
  color: white;
  font-size: 1.5rem;
  font-weight: 800;
  background: ${(props) => props.theme.colors.primary};
  box-shadow: ${(props) => props.theme.shadow.box};
  border-radius: 25px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  z-index: 30;
`;

export const TaskTotalWrapContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: flex-end;
  width: 100%;
`;

export const TaskContainer = styled.div`
  overflow: auto;
  position: relative;
  display: flex;
  width: 100%;
  min-height: 290px;
  padding: 24px;
  background: ${(props) => props.theme.colors.white};
  box-shadow: ${(props) => props.theme.shadow.box};
  border-radius: 16px;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  gap: 20px;
  z-index: 30;

  &::-webkit-scrollbar {
    width: 3px;
    height: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #a9a9a9;
  }

  @media (max-height: 360px) {
    min-height: 43vh;
    max-height: calc(100vh - 82px);
  }
`;

export const TaskContent = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 18px;
`;

export const TaskHeadBox = styled.div`
  display: flex;
  width: 100%;
  font-weight: 600;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const Sbox = styled.div`
  display: flex;
  justify-content: start;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
`;

export const StepBox = styled.div`
  display: flex;
  height: 22px;
  padding: 0 6px;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.theme.colors.primary};
  color: white;
  border-radius: 4px;
  font-size: 1.2rem;
  font-weight: 600;
`;

export const StateBox = styled.p`
  font-weight: 800;
  color: ${(props) => props.theme.colors.primary};
  font-size: 1.5rem;
`;

export const DateBox = styled.p`
  color: ${(props) => props.theme.colors.placeholderTxt};
  font-size: 1.2rem;
  font-weight: 500;
`;

// 진행바(가상요소) <ProgressBarProps>  div뒤에
export const ProgressBar = styled.div<ProgressBarProps>`
  width: 100%;
  height: 10px;
  display: flex;
  position: relative;
  align-items: center;
  border-radius: 20px;
  background: ${(props) => props.theme.colors.mainBg};

  &::after {
    content: "";
    position: absolute;
    display: block;
    height: 10px;
    width: ${(props) => props.progress};
    /* 
    1단계: width: 15%;
    2단계: width: 30%;
    3단계: width: 50%;
    4단계: width: 65%;
    5단계: width: 85%;
    6단계: width: 100%; */
    border-radius: 20px;
    top: 0px;
    left: 0px; /* 왼쪽 패딩을 고려한 위치 조정 */
    background: ${(props) => props.theme.colors.primary};
  }
`;

export const LocationBox = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  gap: 6px;
`;

export const AreaBox = styled.div`
  display: flex;
  font-size: 1.8rem;
  font-weight: 600;
  line-height: 22px;
  flex-direction: column;
  gap: 2px;

  span {
    font-size: 1.4rem;
    font-weight: 500;
    opacity: 0.8;
  }
`;

export const ButtonBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const Button = styled.button<{
  width: string;
  color: string;
  isErrorCheck?: boolean;
}>`
  width: ${(props) => props.width};
  border: none;
  border-radius: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 15px;
  gap: 6px;
  background: ${(props) =>
    props.color === "primary" && !props.isErrorCheck
      ? props.theme.colors.disabledBtn
      : props.color === "primary"
      ? props.theme.colors.primary
      : "none"};
  color: ${(props) =>
    props.color === "primary"
      ? props.theme.colors.white
      : props.theme.colors.primary};
`;

export const BText = styled.p`
  font-size: 1.8rem;
  font-weight: 550;
`;

export const DetailContents = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
`;

export const ContainerBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  flex: 1;
  gap: 3px;
`;

export const TableHeader = styled.p`
  font-size: 1.4rem;
  font-weight: 500;
  white-space: nowrap;
  color: ${(props) => props.theme.colors.contentLabelTxt};
`;

export const TableCell = styled.p`
  font-size: 1.6rem;
  font-weight: 600;
`;

export const PostImgBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
`;

export const PostImg = styled.div`
  width: 100%;
  height: 76px;
  border-radius: 15px;
  overflow: scroll;
  /* overflow: hidden; */
`;

export const CameraAlbumBox = styled.div`
  width: 50%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 6px;
`;

export const PostCamera = styled.div<FileEditBtnProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 6px;
  font-size: 1.4rem;
  font-weight: 600;
  color: ${(props) => props.theme.colors.camerFont};
  border: 1px solid ${(props) => props.theme.colors.camerFont};
  border-radius: 15px;
  padding: 6px 12px 6px 12px;

  input {
    display: none;
  }
`;

export const PostAlbum = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 6px;
  font-size: 1.4rem;
  font-weight: 600;
  /* color: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.camerFont};
  background: ${(props) => props.theme.colors.camerFont}; */
  color: ${(props) => props.theme.colors.camerFont};
  white-space: nowrap;
  border: 1px solid ${(props) => props.theme.colors.camerFont};
  background: ${(props) => props.theme.colors.white};
  border-radius: 15px;
  padding: 6px 12px 6px 12px;

  input {
    display: none;
  }
`;

export const PostImgText = styled.div`
  width: 100%;
  height: 100%;
  img {
    width: 100%;
    height: 100%;
    border-radius: 4px;
  }
`;

export const PostImgTextNone = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 6px;
  font-size: 1.2rem;
  font-weight: 500;
  color: ${(props) => props.theme.colors.labelTxt};

  svg {
    width: 55%;
    height: 55%;
  }

  input {
    display: none;
  }

  &.none {
    display: none;
    svg,
    label {
      display: none;
    }
  }
`;

export const CheckBoxGroup = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const TaskCardCheckBox = styled.div<any>`
  display: flex;
  width: 100%;
  padding: 9px 12px;
  justify-content: flex-start;
  align-items: center;
  border-radius: 4px;
  gap: ${(props) => (props.divGap ? props.divGap : "")};

  font-size: 1.4rem;
  font-weight: 500;

  color: ${(props) => props.theme.colors.contentLabelTxt}9F;
  border: 1px solid ${(props) => props.theme.colors.inputBorder};

  &.checked {
    border: 1px solid ${(props) => props.theme.colors.primary}1F;
    background: ${(props) => props.theme.colors.primary}0F;
    color: ${(props) => props.theme.colors.primary};
  }
`;
